import { render } from "./renew.vue?vue&type=template&id=3613c9f9&scoped=true"
import script from "./renew.vue?vue&type=script&lang=ts"
export * from "./renew.vue?vue&type=script&lang=ts"

import "./renew.vue?vue&type=style&index=0&id=3613c9f9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3613c9f9"

export default script